import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useAddCard = (onSuccess: (res: { id: string }) => void) => {
  const mutation = useMutation({
    mutationFn: async () => {
      const paymentWindow = window.open('/payment/loader', '_blank');
      const res = await API.addCard();
      const url = res.data.redirect_url;
      const id = res.data.payment_id;
      if (paymentWindow) paymentWindow.location.href = url;

      return { url, id };
    },
    onSuccess: (data) => {
      const paymentWindow = window.open('/payment/loader', '_blank');

      if (paymentWindow) paymentWindow.location.href = data.url;
      onSuccess(data.id);
    },
  });

  return {
    addCard: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
    errorAdd: mutation.error,
  };
};
